import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import {
  M8PaginationParams,
  M8PagedResponse,
  M8DebitDTO,
  M8DebitSortableField,
} from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = M8PaginationParams<M8DebitSortableField>;

export const getDebits = async (
  params: Params
): Promise<null | M8PagedResponse<M8DebitDTO>> => {
  const response = await customFetch(
    getM8AdminURL(`getDebits?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
